//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { StudentProfileDisplayItem } from './StudentProfileDisplayItem';
import { TeacherNameDisplayItem } from './TeacherNameDisplayItem';
import { PackageSummaryDisplayItem } from './PackageSummaryDisplayItem';
import { EventCategoryNameDisplayItem } from './EventCategoryNameDisplayItem';
import { BillingProfileDefaultMode } from './Enums';

export class BillingProfileDisplayItem extends ItemBase {
    Active: boolean = false;
    BillingRate: number | null = null;
    DefaultBillingMode: BillingProfileDefaultMode = BillingProfileDefaultMode.None;
    EventCategoryID: string | null = null;
    LessonDuration: number = 0;
    MakeupMinutes: number = 0;
    ScheduledMakeupMinutes: number | null = null;
    StudentID: string | null = null;
    TeacherID: string | null = null;
    Student: StudentProfileDisplayItem | null = null;
    Teacher: TeacherNameDisplayItem | null = null;
    PackageSummary: PackageSummaryDisplayItem | null = null;
    EventCategory: EventCategoryNameDisplayItem | null = null;

    constructor(initializer?: Partial<BillingProfileDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "BillingProfileDisplayItem";
}
